import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  DurationUnits,
  RunMode,
} from '../base/baseSchema.js';
import { BlockValueUsPhoneNumberSchema } from '../base/blockValueUsPhoneNumberSchema.js';

export const SendSmsBlockConfigSchema = z.object({
  calleePhoneNumber: BlockValueUsPhoneNumberSchema({ isRequired: true }),
  callerPhoneNumberId: z.string().uuid('Must be a valid phone number configuration id.').nullish(),
  message: z.string().min(1, 'This field is required.'),
  timeout: DurationSchemaWithMax('value', { value: 60, units: DurationUnits.Minutes }),
  runMode: z.nativeEnum(RunMode).optional().default(RunMode.Live),
});
export type SendSmsBlockConfig = z.infer<typeof SendSmsBlockConfigSchema>;

export const SendSmsBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.SendSms),
  config: SendSmsBlockConfigSchema,
});
export type SendSmsBlock = z.infer<typeof SendSmsBlockSchema>;
